import { useQuery } from "@tanstack/react-query";
import { useRouter } from "next/router";
import { getDClinicalEducationalContentOne } from "api/developmentResearchUser";
import { ContentDetail } from "components/General/Pages/ContentDetail";

const ClinicalContentDetail = () => {
  const router = useRouter();
  const { locale, query } = router;
  const id = parseInt(query?.id as string);

  const { data, isLoading } = useQuery(
    ["getDClinicalEducationalContentOne", locale, id?.toString()],
    () => getDClinicalEducationalContentOne(id)
  );

  return <ContentDetail data={data?.data} isLoading={isLoading} />;
};

export { ClinicalContentDetail };
